import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { TitleContext } from "../../../Context/TitleContext";
import { API_URL, useAxios } from "../../../utils/const";
import toast, { Toaster } from "react-hot-toast";

import { useToast } from "../../../Context/ToastContext";
import RestoreModal from "./RestoreModal";

const BackupRestore = () => {
  const { setTitle } = useContext(TitleContext);
  const { setToastObj } = useToast();
  const axiosInstance = useAxios();
  const [showRestoreModal, setShowRestoreModal] = useState(false);

  const [backups, setBackups] = useState([]);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTitle("USAKTI | Manajemen Pengguna"); // Set judul halaman
  }, [setTitle]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        await getBackups();
      } catch (error) {
        setToastObj({
          msg: error,
          type: "danger",
        });
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const getBackups = async () => {
    const response = await axiosInstance.get(`${API_URL}/backups/list`);
    setBackups(response.data.backups);
  };

  const getDateFromBackup = (filename) => {
    return filename.replace("backup-", "").split(" ")[0];
  };

  const confirmBackup = () => {
    confirmDialog({
      message:
        "Anda akan membuat backup terbaru. Pastikan tidak ada perubahan data yang belum disimpan. Lanjutkan?",
      header: "Confirmation",
      icon: "pi pi-exclamation-triangle",
      defaultFocus: "accept",
      accept: () => handleBackup(),
    });
  };

  const handleBackup = async () => {
    try {
      await axiosInstance.post(`${API_URL}/backups`);
      toast.success("Backup data berhasil dibuat dan disimpan.!");
      getBackups();
    } catch (error) {
      console.log(error);
      toast.error(
        error.response?.data?.msg || error.message || "Failed to backup."
      );
    }
  };

  return loading == false ? (
    <div>
      <ConfirmDialog />
      <Toaster position="top-right" />
      <div className="container">
        <div className="card mb-4">
          <div className="card-body">
            <h1>Backup / Restore</h1>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/">Dashboard</Link>
              </li>
              <li className="breadcrumb-item active">Backup / Restore</li>
            </ol>
          </div>
        </div>

        <div className="card">
          <div className="card-body m-3">
            <div className="row">
              <div
                className="col-md-12 d-flex gap-2"
                style={{ justifyContent: "end" }}
              >
                <button
                  className="btn btn-success"
                  onClick={() => confirmBackup()}
                >
                  <i className="fas fa-cloud-upload-alt"></i> Backup
                </button>
                <button
                  className="btn btn-primary"
                  onClick={() => setShowRestoreModal(true)}
                >
                  <i className="fas fa-cloud-download-alt"></i> Restore
                </button>
              </div>
            </div>
            <div className="row mt-3">
              <div className="col-md-4 text-center offset-md-4">
                <h4>Daftar File</h4>
              </div>
            </div>

            <div className="table-responsive">
              {/* Tabel Data Pengguna */}
              <table className="table table-striped mt-3">
                <thead>
                  <tr>
                    <th className="align-middle text-center">NO</th>
                    <th className="align-middle text-center">FILE</th>
                    <th className="align-middle text-center">TANGGAL</th>
                  </tr>
                </thead>
                <tbody>
                  {backups.length === 0 ? (
                    <tr>
                      <td colSpan="7" className="text-center">
                        Data tidak ditemukan
                      </td>
                    </tr>
                  ) : (
                    backups.map((b, index) => (
                      <tr key={b.id}>
                        <td className="text-center">{index + 1}</td>
                        <td className="text-center">{b}</td>
                        <td className="text-center">{getDateFromBackup(b)}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <RestoreModal
        backups={backups}
        visible={showRestoreModal}
        onHide={() => setShowRestoreModal(false)}
      />
    </div>
  ) : (
    <div>
      <div className="row">
        <div
          className="col-md-12 text-center align-center"
          style={{ marginTop: "20%" }}
        >
          <h1>Mohon Tunggu</h1>
        </div>
      </div>
    </div>
  );
};

export default BackupRestore;
